const InViewFactory = require('kudago-in-view');
const ajax = require('component-ajax');
const throttle = require('lodash/throttle');
const isEmpty = require('lodash/isEmpty');
const emit = require('emmy/emit');
const AdvertButton = require('./advert-button');

class ConvertingPlacesWidget {
  constructor({ el }) {
    this.requestInProcess = false;
    this.el = el;

    this.inView = InViewFactory();
    this.inView.offset(-100);

    this.AdButton = new AdvertButton();

    // we have to declare this method on instance
    // to unbind it later
    this.handleScroll = throttle(() => {
      if (this.isVisible()) {
        this.fetch();
      }
    }, 400);

    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  }

  unbind() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  isVisible() {
    return this.inView.is(this.el);
  }

  render(data) {
    const content = data.converting;

    if (isEmpty(content) || !content.trim()) {
      return;
    }

    this.el.innerHTML = content;
    this.el.classList.remove('preloading');

    const hiddenParent = this.el.closest('[hidden]');
    if (hiddenParent) {
      hiddenParent.removeAttribute('hidden');
    }

    this.AdButton.update();
  }

  fetch() {
    // prevent fetching of data twice
    // that also makes the widget render twice
    if (this.requestInProcess) {
      return;
    }

    const mixes = kudago.itemPageNames;
    const data = {
      location: kudago.location,
      slug: window._metricsConfig.item.slug,
    };

    if (mixes) {
      data.mixes = mixes;
    }

    this.requestInProcess = true;

    ajax({
      url: '/widgets/converting-places/',
      data,
      success: (response) => {
        if (response) {
          this.render(response);
          emit(document, 'special-widgets-loaded');
        }

        this.unbind();
      },
      error: () => {
        this.requestInProcess = false;
      },
    });
  }
}

module.exports = ConvertingPlacesWidget;
